import { BsonDocument, NotificationType, NotificationSettings } from "@/API";
import { Button, Group, Modal, Select, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect, useRef, useState } from "react";
import { LineNotificationSettingsDataEdit } from "./Line/LineNotificationSettingsDataEdit";
import { AppriseNotificationSettingsDataEdit } from "./Apprise/AppriseNotificationSettingsDataEdit";


export function NotificationSettingsEditButton(props: { workspaceId: string, type?: NotificationType, initValue?: NotificationSettings, onChange?: (value: NotificationSettings) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const [notificationData, setNotificationData] = useState<BsonDocument>({})
    const childFormRef = useRef<{ validate: () => { hasErrors: boolean } }>(null);

    const form = useForm<NotificationSettings>({
        initialValues: {
            type: props.type ?? "Line",
            ...props.initValue
        },
    });
    useEffect(() => {
        if (opened) {
            form.setValues({ type: props.type ?? "Line", ...props.initValue } as any)
            setNotificationData(props.initValue?.notificationData ?? {})
        }
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="通知設定">
            <form onSubmit={form.onSubmit((values) => {
                if (childFormRef.current) {
                    const result = childFormRef.current.validate();
                    if (result.hasErrors) return;
                }
                values.notificationData = notificationData
                props.onChange?.(values)
                close()
            })}>
                <Select
                    label="通知類型"
                    data={[
                        { value: 'Line', label: 'Line' },
                        { value: 'Apprise', label: 'Apprise' }
                    ]}
                    disabled={!!props.initValue?.id}
                    {...form.getInputProps('type')}
                />
                <TextInput
                    label="名稱"
                    {...form.getInputProps('name')}
                />
                {
                    form.values.type == "Line" && <LineNotificationSettingsDataEdit ref={childFormRef} value={notificationData} onChange={setNotificationData} />
                }
                {
                    form.values.type == "Apprise" && <AppriseNotificationSettingsDataEdit ref={childFormRef} value={notificationData} onChange={setNotificationData} />
                }
                <Group justify="flex-end" mt="md">
                    <Button type="submit">確認</Button>
                </Group>
            </form>
        </Modal>
    </>
}